import { render, staticRenderFns } from "./random.vue?vue&type=template&id=5bdf09a3&scoped=true&"
import script from "./random.vue?vue&type=script&lang=js&"
export * from "./random.vue?vue&type=script&lang=js&"
import style0 from "./random.vue?vue&type=style&index=0&id=5bdf09a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf09a3",
  null
  
)

export default component.exports